import { useEffect, useState } from "react";

export const useAppcuesBannerHeight = () => {
  const [appcuesBannerHeight, setAppcuesBannerHeight] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      const appcuesBanner = window.document.querySelector(
        "appcues-experience-container",
      ) as HTMLDivElement | null;

      if (appcuesBanner) {
        if (appcuesBanner.style.position === "sticky") {
          const rect = appcuesBanner.getBoundingClientRect();
          setAppcuesBannerHeight(rect.height);
        }
      } else {
        setAppcuesBannerHeight(0);
      }
    }, 1000);

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, []);

  return appcuesBannerHeight;
};
